module.exports = __webpack_public_path__ + "92cbf5cba6eebe80e7a536e63b1368bf.pdf";